import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import { capitalize } from '@/modules/mm-utils';
import { lens, getIndexedCollection } from '@/common/helpers';
/**
 * @typedef AddMutationParams
 * @property {any[]} items - items to add
 * @property {any=} uniqueKey - name of the unique field of the object
 * @property {boolean=} isForce - true if need overwrite the existing entity
 */

/**
 * @typedef SetMutationParams
 * @property {any[]} items - items to add
 */

/**
 * @typedef DeleteMutationParams
 * @property {any[]} items - items to add
 * @property {any=} uniqueKey - name of the unique field of the object
 */

/**
 * @typedef {(object: state, payload: AddMutationParams) => void} AddMutation
 */

/**
 * @typedef {(object: state, payload: SetMutationParams) => void} SetMutation
 */

/**
 * @typedef {(object: state, payload: DeleteMutationParams) => void} DeleteMutation
 */

/**
 * @typedef {(object: state, payload: DeleteMutationParams) => void} UpdateMutation
 */

/**
 * @typedef {Object<string, AddMutation|SetMutation|DeleteMutation>} GenericMutations
 */

/**
 * @typedef {(object: state) => object} IndexedGetter
 */

/**
 * @typedef {Object<string, IndexedGetter>} GenericGetters
 */

/**
 * Generic add mutation. It adds new items into the existed array and do not overwrite
 * if isForced key is not provided
 * @param {string} entity - entity name from the state
 * @returns {AddMutation}
 */

export var addItemsMutation = function addItemsMutation(entity) {
  return function (state, _ref) {
    var items = _ref.items,
        _ref$uniqueKey = _ref.uniqueKey,
        uniqueKey = _ref$uniqueKey === void 0 ? 'id' : _ref$uniqueKey,
        _ref$isForce = _ref.isForce,
        isForce = _ref$isForce === void 0 ? false : _ref$isForce;
    var keyMap = new Map();
    var keys = lens(items, uniqueKey);
    keys.forEach(function (key) {
      return keyMap.set(key, true);
    });
    var filteredArr = state[entity].filter(function (el) {
      return !keyMap.get(el[uniqueKey]);
    });
    var existedItems = state[entity].filter(function (el) {
      return keyMap.get(el[uniqueKey]);
    });

    if (existedItems.length !== items.length || isForce) {
      state[entity] = [].concat(_toConsumableArray(filteredArr), _toConsumableArray(items));
    }
  };
};
/**
 * Generic set mutation. It sets the new value for the existed array
 * @param {string} entity - entity name from the state
 * @returns {SetMutation}
 */

export var setItemsMutation = function setItemsMutation(entity) {
  return function (state, _ref2) {
    var items = _ref2.items;
    state[entity] = _toConsumableArray(items);
  };
};
/**
 * Generic delete mutation. It removes the items from the existed array
 * @param {string} entity - entity name from the state
 * @returns {DeleteMutation}
 */

export var deleteItemsMutation = function deleteItemsMutation(entity) {
  return function (state, _ref3) {
    var items = _ref3.items,
        _ref3$uniqueKey = _ref3.uniqueKey,
        uniqueKey = _ref3$uniqueKey === void 0 ? 'id' : _ref3$uniqueKey;
    var keyMap = new Map();
    var keys = lens(items, uniqueKey);
    keys.forEach(function (key) {
      return keyMap.set(key, true);
    });
    state[entity] = state[entity].filter(function (el) {
      return !keyMap.get(el[uniqueKey]);
    });
  };
};
/**
 * Generic update mutation. It replaces the items in the existed array
 * @param {string} entity - entity name from the state
 * @returns {UpdateMutation}
 */

export var updateItemsMutation = function updateItemsMutation(entity) {
  return function (state, _ref4) {
    var items = _ref4.items,
        _ref4$uniqueKey = _ref4.uniqueKey,
        uniqueKey = _ref4$uniqueKey === void 0 ? 'id' : _ref4$uniqueKey;
    var keyMap = new Map();
    var keys = lens(items, uniqueKey);
    keys.forEach(function (key) {
      return keyMap.set(key, true);
    });
    var arrWithoutItems = state[entity].filter(function (el) {
      return !keyMap.get(el[uniqueKey]);
    });
    state[entity] = [].concat(_toConsumableArray(arrWithoutItems), _toConsumableArray(items));
  };
};
/**
 * Returns an object contains the generic add, set and delete mutations
 * for the entities which are an array type
 * @param {object} state - vuex state
 */

export function getUniversalMutations(state) {
  var entities = Object.keys(state).filter(function (el) {
    return Array.isArray(state[el]);
  });
  /**
   * @type {GenericMutations}
   */

  var mutations = {};
  entities.forEach(function (entity) {
    var addKey = "add".concat(capitalize(entity));
    var setKey = "set".concat(capitalize(entity));
    var updateKey = "update".concat(capitalize(entity));
    var deleteKey = "delete".concat(capitalize(entity));
    mutations[addKey] = addItemsMutation(entity);
    mutations[setKey] = setItemsMutation(entity);
    mutations[updateKey] = updateItemsMutation(entity);
    mutations[deleteKey] = deleteItemsMutation(entity);
  });
  return mutations;
}
/**
 * Returns an object contains the generic getters
 * for the entities which are an array type
 * @param {object} state - vuex state
 */

export function getUniversalGetters(state) {
  var entities = Object.keys(state).filter(function (el) {
    return Array.isArray(state[el]);
  });
  /**
   * @type {GenericGetters}
   */

  var getters = {};
  entities.forEach(function (entity) {
    var indexedKey = "".concat(entity, "Indexed");

    getters[indexedKey] = function (state) {
      return getIndexedCollection(state[entity], 'id');
    };
  });
  return getters;
}